import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { IExchangeRate } from '@lib/interfaces';

@Injectable({
    providedIn: 'root',
})
export class SettingsService {
    environment_url: string;
    settingsDetails: EventEmitter<any> = new EventEmitter();
    constructor(private http: HttpClient) {
        this.environment_url = environment.api_url;
    }

    public setTenantSetting(payload: any): Observable<any> {
        return this.http.post<any>(`${this.environment_url}nfront/v1/proxy/tenantsettings/portalconfiguration`, payload);
    }

    public updateTenantSetting(id: string, payload: any): Observable<any> {
        return this.http.put<any>(`${this.environment_url}nfront/v1/proxy/tenantsettings/portalconfiguration/${id}`, payload);
    }

    public getTenantSetting(): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/tenantsettings/portalconfiguration/metadata`);
    }
    public getExchangeRates(searchPayload: IExchangeRate): Observable<IExchangeRate> {
        return this.http.post<IExchangeRate>(`${this.environment_url}nfront/v1/proxy/fxrates:search`, searchPayload);
    }

    public updateExchangeRate(fxratesId: string, exchangeRate: any): Observable<IExchangeRate> {
        return this.http.put<IExchangeRate>(`${this.environment_url}nfront/v1/proxy/fxrates/${fxratesId}/rate`, exchangeRate);
    }
}
